import { Box, Chip, Typography } from "@mui/material";
import React from "react";
import { useHttpHookLoad } from "../../../hook/page/block/httpHook";
import { LoadBoundary } from "../../brand/LoadBoundary";
import { HttpHookBlock } from "../../../types/notebook/note/block/httpHook";
import { NoteBlockContainer } from "../../note";
import { CopyClipboard } from "../../copyClipboard";

export const HttpHookBlockComponent: React.FC<{
  block: HttpHookBlock;
}> = React.memo(({ block }) => {
  const { "hook-id": hookId } = block;
  const { httpHook, status, retry } = useHttpHookLoad(hookId);

  const omegaUrl = process.env.REACT_APP_OMEGA_URL ?? "https://db.queryomega.com";
  const url = httpHook?.["endpoint-id"]
    ? `${omegaUrl}/hook/${httpHook["endpoint-id"]}`
    : undefined;

  return (
    <NoteBlockContainer name="HTTP Hook">
      <LoadBoundary
        status={status}
        onRetry={retry}
        label="Loading HTTP hook"
        errorMessage="Could not load this HTTP hook."
        testId="http-hook-loading"
      >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" color="text.secondary">URL</Typography>
          {url ? (
            <>
              <Chip label={url} size="small" variant="outlined" />
              <CopyClipboard value={url} />
            </>
          ) : (
            <Typography variant="body2" color="text.secondary">Registering…</Typography>
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" color="text.secondary">Handler</Typography>
          <Typography variant="body2">
            {httpHook ? `${httpHook["proto-name"]}/${httpHook["method-name"]}` : "—"}
          </Typography>
        </Box>
      </Box>
      </LoadBoundary>
    </NoteBlockContainer>
  );
});
